export default __webpack_public_path__ + "static/Entenda0106-7d5c9fab79c0c1a364549fc65f04ccc7.jpg";